import { render, staticRenderFns } from "./info.vue?vue&type=template&id=7ea5f2a1&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=7ea5f2a1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea5f2a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea5f2a1')) {
      api.createRecord('7ea5f2a1', component.options)
    } else {
      api.reload('7ea5f2a1', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=7ea5f2a1&scoped=true", function () {
      api.rerender('7ea5f2a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mvms/components/info.vue"
export default component.exports